import { render, staticRenderFns } from "./employeerelation.vue?vue&type=template&id=0fc72a60&scoped=true&"
import script from "./employeerelation.vue?vue&type=script&lang=js&"
export * from "./employeerelation.vue?vue&type=script&lang=js&"
import style0 from "./employeerelation.vue?vue&type=style&index=0&id=0fc72a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc72a60",
  null
  
)

export default component.exports